import { type PropsWithChildren, type ReactNode } from 'react';
import { useIsMounted } from '@toss/react';
import { useRouter } from 'next/router';
export const NoSSR = ({
  children,
  fallback
}: PropsWithChildren<{
  fallback?: ReactNode;
}>) => {
  const isMounted = useIsMounted();
  const {
    isReady
  } = useRouter();
  if (!isMounted || !isReady) {
    const hasFallback = Boolean(fallback);
    return hasFallback ? fallback : null;
  }
  return <>{children}</>;
};